// Authentication Configuration
// Change these credentials as needed

export const AUTH_CONFIG = {
  username: 'zetaris',
  password: 'Zetaris@1234',

  // Session settings
  sessionKey: 'zetaris_hubspot_auth',
  sessionTimeout: 8 * 60 * 60 * 1000, // 8 hours in milliseconds
};
